const placementStateKey = '__referenceProductHighlightsPlacement';

if (!window[placementStateKey]) {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const placeholders = new WeakMap();

  const syncFooterNavigation = (navigation) => {
    const main = document.querySelector('#MainContent');
    if (!main) return;

    let destination = main.querySelector(':scope > [data-reference-footer-navigation]');

    if (!destination) {
      destination = document.createElement('div');
      destination.className = 'reference-footer-navigation section section--page-width page-width-normal';
      destination.dataset.referenceFooterNavigation = '';
      main.append(destination);
    }

    destination.append(navigation);
  };

  const syncHighlight = (highlight) => {
    let placeholder = placeholders.get(highlight);

    if (!placeholder) {
      placeholder = document.createComment('Product highlights desktop position');
      highlight.before(placeholder);
      placeholders.set(highlight, placeholder);
    }

    if (!mobileQuery.matches) {
      if (placeholder.isConnected) placeholder.after(highlight);
      return;
    }

    const productSection = highlight.closest('.product-information');
    const details = productSection?.querySelector('.product-details');
    const upgrades = details?.querySelector('.reference-upgrades');
    const buyButtons = details?.querySelector('.buy-buttons-block');
    const inventory = details?.querySelector('product-inventory');

    if (upgrades) {
      upgrades.after(highlight);
    } else if (buyButtons) {
      buyButtons.before(highlight);
    } else if (inventory) {
      inventory.after(highlight);
    }
  };

  const syncAllHighlights = () => {
    document.querySelectorAll('[data-reference-highlights-placement]').forEach(syncHighlight);
    document.querySelectorAll('.reference-highlights__nav').forEach(syncFooterNavigation);
  };

  const removeSectionNavigation = (event) => {
    const sectionId = event.detail?.sectionId;
    if (!sectionId) return;

    document.querySelectorAll('.reference-highlights__nav[data-reference-owner-section]').forEach((navigation) => {
      if (navigation.dataset.referenceOwnerSection === sectionId) navigation.remove();
    });

    document.querySelectorAll('[data-reference-footer-navigation]:empty').forEach((destination) => destination.remove());
  };

  mobileQuery.addEventListener('change', syncAllHighlights);
  document.addEventListener('shopify:section:load', syncAllHighlights);
  document.addEventListener('shopify:section:unload', removeSectionNavigation);
  window[placementStateKey] = { sync: syncAllHighlights };
}

window[placementStateKey].sync();
